import { render, staticRenderFns } from "./customerC.vue?vue&type=template&id=4cf6f5ad&scoped=true&"
import script from "./customerC.vue?vue&type=script&lang=js&"
export * from "./customerC.vue?vue&type=script&lang=js&"
import style0 from "./customerC.vue?vue&type=style&index=0&id=4cf6f5ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6f5ad",
  null
  
)

export default component.exports